import React from "react";
import ComingsoonPageComponent from "./comingsoonPage";
import "./comingsoonPage.scss";

const ComingsoonPage = () => {
  return <ComingsoonPageComponent />;
};

export default ComingsoonPage;
